export default "__VITE_ASSET__lHxIQsvH__"